import React from 'react';
import { Link } from 'react-router-dom';
import Text from '../text/Text';
import Button from '../button/Button';
import { FormationCard } from '../formationCard/FormationCard';
import { formationsData } from '../../data/formations';
import './styles.css';

export const Formations = () => {
    const featuredFormations = formationsData.slice(0, 3);

    return (
        <div className='container'>
            <div className='content'>
                <Text variant='yellow-green' as='h1' fontSize={56}>Formações</Text>
                <div className='formations-content'>
                    <div className='formations-row'>
                        {featuredFormations.map(formation => (
                            <FormationCard key={formation.id} formation={formation} />
                        ))}
                    </div>
                    <Link to='/formacoes'>
                        <Button variant='gradient'>
                            Veja Mais
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
};


export const AllFormations = () => {
    //exibe apenas 3 por linha
    const groupFormationsInRows = (data, itemsPerRow = 3) => {
        const rows = [];
        for (let i = 0; i < data.length; i += itemsPerRow) {
            rows.push(data.slice(i, i + itemsPerRow));
        }
        return rows;
    };

    const formationRows = groupFormationsInRows(formationsData);

    return (
        <div className='container'>
            <div className='content'>
                <Text variant='yellow-green' as='h1' fontSize={56}>Formações</Text>
                <div className='formations-content'>
                    {formationRows.map((row, index) => (
                        <div key={index} className='formations-row'>
                            {row.map(formation => (
                                <FormationCard key={formation.id} formation={formation} />
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};